export const schemaBreadcrumbLDJSON = (breadcrumbs) => {
  const breadcrumbArray = breadcrumbs.map(({ text, url }, i) => {
    const crumb = {
      '@type': 'ListItem',
      position: i + 1,
      name: text,
    };
    if (url) crumb.item = `${url}`;

    return crumb;
  });
  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbArray,
  });

  return schema;
};

export const schemaBreadcrumbLDJSONScript = (breadcrumbs) => {
  const schema = schemaBreadcrumbLDJSON(breadcrumbs);
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.innerHTML = schema;

  return script;
};
